import React from 'react';
import { Image, PageContent, Title4, TextLarge, SecondaryButton } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { trackGAEvent } from '../../../utils/gaTracking';
import SellBlock from '../../SellBlock/components/SellBlock';
import PageBackground from '../../PageBackground/components/PageBackground';
import { EnvironmentProvider } from '../../../contexts/EnvironmentContext';

import Classes from './SellPageContent.scss';
import { TEnvConfigCars } from 'types/TServerContext';

type TSellPageContentProps = {
  environment: TEnvConfigCars;
  appState: any;
};

const SellPageContent = ({ environment, appState }: TSellPageContentProps) => {
  const { t } = useI18nContext();
  const {
    links: { imagesSources },
  } = environment;

  return (
    <EnvironmentProvider value={environment}>
      <section className="Page-section Page-section--full-width">
        <PageBackground />
        <PageContent className={Classes.intentContent}>
          <section className={Classes.sellSection}>
            <h1 className="hz-Title hz-Title--title4 sectionHeader Page-title">{t('page.title.sell.cars')}</h1>
            <SellBlock withLicensePlateField={appState.withLicensePlateField} />
          </section>
          <section className="PageContent-card PageContent-offset">
            <div className={Classes.contentCard}>
              <div className={Classes.contentBody}>
                <Title4 utilities={['marginBottomS']}>{t('sell.content.cars.title')}</Title4>
                <TextLarge utilities={['marginBottomXxs']}>{t('sell.content.cars.body1')}</TextLarge>
                <TextLarge utilities={['marginBottomL']}>{t('sell.content.cars.body2')}</TextLarge>
                <SecondaryButton
                  as="a"
                  href="/plaats/91"
                  onClick={() => {
                    trackGAEvent('placeAdButtonClicked', 'article');
                  }}
                >
                  {t('cars.sell.place_ad_button2')}
                </SecondaryButton>
              </div>
              <div className={Classes.contentImage}>
                {imagesSources && Boolean(imagesSources?.length) && (
                  <Image
                    src={imagesSources[0]}
                    srcSet={`${imagesSources[0]} 1x, ${imagesSources[1]} 2x`}
                    alt=""
                    loading="lazy"
                    fetchpriority="low"
                    decoding="async"
                    //@ts-expect-error -- DS issue
                    aspectRatio=""
                    fit
                  />
                )}
              </div>
            </div>
          </section>
        </PageContent>
      </section>
    </EnvironmentProvider>
  );
};

export default SellPageContent;
